import Breadcumbs from "../../components/Breadcumbs";
import BlockBackgroundImage from "../../components/BlockBackgroundImage";
import { NavLink } from "react-router-dom";
import BlockImageCabecera from "../../components/BlockImageCabecera";
import PosgradoPagos from "../../components/PosgradoPagos";
import Quote from "../../components/Quote";
import Accordion from "../../components/Accordion";
import BannerGeneral from "../../components/BannerGeneral";
import Flipcard from "../../components/Flipcard";
import Block4ColumnsText from "../../components/Block4ColumnsText";

function CooperacionInternacional() {
  return (
    <>
      <div className="margin ">
        <BlockImageCabecera
          src="https://images.ctfassets.net/112w21q1rvqr/3KQubfeBglUgF6Dx59LnDR/d9b5c11c3bcf616c2e9e3e5ea8130365/posgradosutpl.jpg"
          tag="Ciencias Sociales, Periodismo, Información y Derecho"
          modalidad="a Distancia"
          tipo="Profesional"
          duracion="1 año"
          costo="5300"
          title={
            <>
              <h2>
                Maestría en{" "}
                <b>Cooperación Internacional para el Desarrollo Sostenible</b>
              </h2>
              <p>
                Somos la única maestría que enfoca la gestión de la cooperación
                internacional desde el ámbito de la formulación de proyectos
                para el desarrollo sostenible.
              </p>

              <a href="https://prapps.utpl.edu.ec/ords/utpl_crm/r/registro-utpl/login">
                Postula ahora
              </a>
            </>
          }
        ></BlockImageCabecera>
      </div>

      <Breadcumbs
        content={
          <>
            <NavLink to="/posgrados">Posgrados</NavLink>
            <span class="material-icons">chevron_right</span>
            <NavLink to="/maestria-cooperacion">
              Maestría en Cooperación Internacional
            </NavLink>
          </>
        }
      ></Breadcumbs>

      <div className="layout8 padding2">
        <h3>
          <b>Cooperación Internacional </b>para el Desarrollo Sostenible
        </h3>

        <p>Resolución de aprobación: RPC-SO-33-No.762-2021</p>

        <p>
          {" "}
          Con esta maestría, tendrás la oportunidad de fortalecer tus
          habilidades y destrezas para desempeñarte en roles clave dentro del
          ámbito de la cooperación internacional. Podrás convertirte en gestor
          de proyectos en organismos internacionales, como las Naciones Unidas,
          organizaciones no gubernamentales y agencias de desarrollo, entre
          otras instituciones que se dedican a la cooperación y el desarrollo
          global. Este programa está diseñado para prepararte en la
          planificación, ejecución y evaluación de proyectos que promuevan el
          bienestar global y el desarrollo sostenible.
        </p>
        <div className="padding2 ">
          <Accordion
            title="Requisitos de postulación"
            content={
              <>
                <ul>
                  <li>
                    <p>
                      Copia del título de tercer nivel de grado registrado por
                      el órgano rector de la política pública de educación
                      superior. En el caso que el título de grado sea obtenido
                      en el extranjero deberá ser apostillado o legalizado por
                      vía consular.
                    </p>
                  </li>
                  <li>
                    <p>
                      {" "}
                      Copia a color de la cédula de identidad o pasaporte para
                      extranjeros.
                    </p>
                  </li>
                  <li>
                    <p>
                      {" "}
                      Hoja de vida, acompañada de la documentación de respaldo,
                      que debe ser presentada únicamente en el formato
                      institucional establecido. <a>Descargar</a>
                    </p>
                  </li>

                  <li>
                    <p>
                      Documentación que justifique pertenecer a los cupos
                      especiales (personas con discapacidad, personal
                      administrativo y de servicios y personal académico de la
                      UTPL).
                    </p>
                  </li>
                  <li>
                    <p>Presentarse a la entrevista.</p>
                  </li>
                </ul>
              </>
            }
          >
            {" "}
          </Accordion>
        </div>
        <Quote content="Adquiere perspectivas regionales relevantes y desarrolla habilidades innovadoras para liderar proyectos de cooperación internacional."></Quote>

        <p>
          Asimismo, podrás trabajar como analista en ONG locales o
          internacionales, enfocándote en temas cruciales como el desarrollo
          sostenible, los derechos humanos y la ayuda humanitaria. Tu formación
          te permitirá contribuir de manera significativa a la investigación y
          la implementación de estrategias que aborden estos importantes
          desafíos. Además, la maestría te capacita para ser consultor e
          investigador independiente en centros de investigación que traten
          temas de desarrollo sostenible, así como en proyectos relacionados con
          la cooperación internacional, brindando asesoramiento experto y
          soluciones innovadoras.
        </p>
        <Quote content="Contamos con una destacada trayectoria en la gestión de proyectos Erasmus y la captación de fondos de cooperación internacional."></Quote>
        <p>
          Finalmente, esta maestría también abre puertas en el ámbito académico,
          preparándote para ser docente o investigador en universidades e
          instituciones académicas especializadas en cooperación internacional y
          desarrollo sostenible. Podrás impartir conocimientos avanzados y
          contribuir a la formación de nuevas generaciones de profesionales
          comprometidos con el desarrollo global. Con una sólida base teórica y
          práctica, estarás listo para influir positivamente en la comunidad
          internacional y promover un futuro más equitativo y sostenible.
        </p>
      </div>

      <div className="layout8 padding2">
        <center>
          <h3>
            <b>Plan de </b> estudios
          </h3>
        </center>

        <p>
          El objetivo del plan de estudios es que te formes sobre la gestión del
          desarrollo sostenible de una manera interdisciplinar y especializada.
          La idea es que aprendas a diseñar, implementar y evaluar la
          transformación de las organizaciones y la sociedad hacia la
          sostenibilidad desde una perspectiva económica, social y ecológica.
        </p>
        <br></br>
        <Accordion
          title="Malla académica"
          content={
            <>
              <p>
                <b>Primer semestre</b>
              </p>

              <ul>
                <li>
                  {" "}
                  <p>
                    Contexto del desarrollo y marco de la cooperación
                    internacional
                  </p>
                </li>
                <li>
                  {" "}
                  <p>
                    Cooperación para el desarrollo en América Latina. Estudio de
                    caso de Ecuador.
                  </p>
                </li>
                <li>
                  {" "}
                  <p>
                    Gestión de intervenciones de cooperación internacional (I):
                    El ciclo del proyecto.
                  </p>
                </li>
                <li>
                  {" "}
                  <p>
                    Gestión de intervenciones de cooperación internacional (II):
                    Enfoques y herramientas prácticas.
                  </p>
                </li>
                <li>
                  {" "}
                  <p>Titulación 1</p>
                </li>
              </ul>

              <p>
                <b> Segundo semestre</b>
              </p>

              <ul>
                <li>
                  <p>
                    Gestión de recursos naturales y adaptación al cambio
                    climático
                  </p>
                </li>
                <li>
                  {" "}
                  <p>
                    Emprendimiento innovador y desarrollo productivo sostenible
                  </p>
                </li>
                <li>
                  {" "}
                  <p>
                    Oportunidades laborales en el ámbito de la economía social y
                    empresarial
                  </p>
                </li>
                <li>
                  {" "}
                  <p>Fuentes de financiación a OCS</p>
                </li>
                <li>
                  {" "}
                  <p>Titulación 2</p>
                </li>
              </ul>
            </>
          }
        ></Accordion>
        <Accordion
          title="Brochure"
          content={
            <>
              <a href="https://www.utpl.edu.ec/maestrias/sites/default/files/brochure%20cooperacion.pdf">
                {" "}
                ☝ Descargar brochure
              </a>
            </>
          }
        ></Accordion>
      </div>

      <PosgradoPagos></PosgradoPagos>

      <div className="layout8 padding2">
        <center>
          <h3>
            Acceso y <b>salidas profesionales</b>
          </h3>
        </center>

        <Accordion
          title="Perfil de ingreso"
          content={
            <>
              <p>Este programa esta dirigido a profesionales en campos de:</p>
              <ul>
                <li>
                  <p>Ciencias sociales</p>
                </li>
                <li>
                  <p>Periodismo</p>
                </li>
                <li>
                  <p>Información</p>
                </li>
                <li>
                  <p>Derecho</p>
                </li>
                <li>
                  <p>Administración</p>
                </li>
                <li>
                  <p>Otros afines con experiencia en el área</p>
                </li>
              </ul>
            </>
          }
        ></Accordion>
        <Accordion
          title="Perfil profesional"
          content={
            <>
              <p>
                Esta maestría te dará los conocimientos y habilidades necesarios
                para:
              </p>
              <ul>
                <li>
                  <p>
                    Diseñar proyectos basados en enfoques y herramientas
                    innovadoras para captar fondos de cooperación internacional.
                  </p>
                </li>
                <li>
                  <p>
                    Gestionar intervenciones de cooperación internacional para
                    generar proyectos que aporten a mejorar las condiciones
                    económicas, sociales y ambientales de las personas.
                  </p>
                </li>
                <li>
                  <p>
                    Capacidad para diseñar proyectos de emprendimiento con
                    enfoque sostenible en colaboración con actores locales,
                    utilizando metodologías ágiles y herramientas de innovación
                    para asegurar la efectividad y la eficiencia en la gestión
                    del proyecto.
                  </p>
                </li>
              </ul>
            </>
          }
        ></Accordion>
        <Accordion
          title="Campo ocupacional"
          content={
            <>
              <p>
                {" "}
                Con esta maestría podrás fortalecer tus habilidades y destrezas
                para desempeñarte como:
              </p>
              <ul>
                <li>
                  <p>
                    Analista en ONG locales o internacionales que se centren en
                    temas relacionados con el desarrollo sostenible, derechos
                    humanos, ayuda humanitaria, entre otros.{" "}
                  </p>
                </li>
                <li>
                  <p>
                    Consultor e investigador independiente en centros de
                    investigación enfocados en temas de desarrollo sostenible o
                    como consultor independiente en proyectos relacionados con
                    cooperación internacional.{" "}
                  </p>
                </li>
                <li>
                  <p>
                    Docente o investigador en universidades o instituciones
                    académicas que se centran en temas de cooperación
                    internacional y desarrollo sostenible.{" "}
                  </p>
                </li>
              </ul>
            </>
          }
        ></Accordion>
      </div>

      <div className="layout8 padding2">
        <center>
          <h3>
            <b>Docentes</b>
          </h3>
        </center>

        <div className=" flex-center">
          <Flipcard
            src="https://sica.utpl.edu.ec/media/uploads/docentes/fotos/web/low/1103742522_low.jpg"
            alt="utpl"
            content={
              <>
                <p>
                  <b>Mgtr. Monica Costa</b>
                </p>
                <p>
                  Posee un certificado internacional en Economía Social y
                  Solidaria, destacando su conocimiento y habilidades en esta
                  área específica.
                </p>
                <a href="https://investigacion.utpl.edu.ec/mpcosta">
                  {" "}
                  Ver UTPL ID
                </a>
              </>
            }
          ></Flipcard>
          <Flipcard
            src="https://sica.utpl.edu.ec/media/uploads/docentes/fotos/web/low/1101962452_low.jpg"
            alt="utpl"
            content={
              <>
                <p>
                  <b>Ph. D. Fausto López </b>
                </p>
                <p>
                  Posee más de 14 años de experiencia en conservación ambiental,
                  gracias a su vinculación con una ONG dedicada a este campo.
                </p>
                <a href="https://investigacion.utpl.edu.ec/fvlopezx">
                  {" "}
                  Ver UTPL ID
                </a>
              </>
            }
          ></Flipcard>
          <Flipcard
            src="https://www.utpl.edu.ec/maestrias/sites/default/files/diana_garcia.png"
            alt="utpl"
            content={
              <>
                <p>
                  <b>Mgtr. Diana García</b>
                </p>
                <p>
                  Investigadora en temas de agua, cambio climático y movimientos
                  sociales. Miembro de la Cátedra UNESCO de Sustentabilidad y
                  Cambio Climático.
                </p>
                <a href="https://www.linkedin.com/in/diana-garc%C3%ADa-orellana/">
                  {" "}
                  Ver linkedin
                </a>
              </>
            }
          ></Flipcard>
          <Flipcard
            src="https://www.utpl.edu.ec/maestrias/sites/default/files/maria%20veronica_0.jpg"
            alt="utpl"
            content={
              <>
                <p>
                  <b>Ph. D. María Íñiguez</b>
                </p>

                <a href="https://investigacion.utpl.edu.ec/mviniguez1">
                  {" "}
                  Ver UTPL ID
                </a>
              </>
            }
          ></Flipcard>
          <Flipcard
            src="https://sica.utpl.edu.ec/media/uploads/docentes/fotos/web/low/1103666762_low.jpg"
            alt="utpl"
            content={
              <>
                <p>
                  <b>Ph. D. Eulalia Salas </b>
                </p>
                <p>Experta en gestión de finanzas.</p>
                <a href="https://investigacion.utpl.edu.ec/eesalas ">
                  {" "}
                  Ver UTPL ID
                </a>
              </>
            }
          ></Flipcard>
          <Flipcard
            src=" https://www.utpl.edu.ec/maestrias/sites/default/files/diana_samaniego.png"
            alt="utpl"
            content={
              <>
                <p>
                  <b>Mgtr. Diana Samaniego </b>
                </p>
                <p>Experta en gestión de finanzas.</p>
                <a href="https://investigacion.utpl.edu.ec/eesalas ">
                  {" "}
                  Ver UTPL ID
                </a>
              </>
            }
          ></Flipcard>
        </div>
      </div>

      <div className="bluebg padding icon100">
        <Block4ColumnsText
          col1={
            <>
              <h2>
                ¿Qué nos <b>diferencia?</b>
              </h2>
            </>
          }
          col2={
            <>
            <img src="https://eventos.utpl.edu.ec/sites/default/files/images/icon3.png" alt="utpl"></img>
              <p>
                Desarrollamos competencias en la formulación de proyectos para
                la captación de fondos internacionales.
              </p>
            </>
          }
          col3={
            <>
             <img src="https://eventos.utpl.edu.ec/sites/default/files/images/icon3.png" alt="utpl"></img>
              <p>
                Diseñamos proyectos de vinculación que permiten el
                relacionamiento con organizaciones de cooperación internacional.
              </p>
            </>
          }
          col4={
            <>
             <img src="https://eventos.utpl.edu.ec/sites/default/files/images/icon3.png" alt="utpl"></img>
              <p>
                Generamos espacios de estudio a través de entornos de
                aprendizaje inmersivos.
              </p>
            </>
          }
        ></Block4ColumnsText>
      </div>

      <BannerGeneral></BannerGeneral>
    </>
  );
}

export default CooperacionInternacional;
